module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 bg-lightest border-light card-height-2 d-flex flex-column radius-normal"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "text-center darker font-weight-600 mt-4 fs-large"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center w-100 mb-5 mt-1"
  }, [_c('ul', {
    staticClass: "text-left"
  }, _vm._l((_vm.reportList), function(reportItem) {
    return (reportItem.active) ? _c('li', [_c('router-link', {
      staticClass: "darker",
      attrs: {
        "to": {
          name: reportItem.link,
          params: {}
        }
      }
    }, [_vm._v(_vm._s(reportItem.label))])], 1) : _vm._e()
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-802bc5f0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/cardReportList.vue
// module id = 2573
// module chunks = 0